"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GroupField = (function () {
    function GroupField(input) {
        this._dataField = input.dataField;
        this._displayField = input.displayField || input.dataField;
        this._notFoundText = input.notFoundText || "";
        this._tableField = input.tableField || input.dataField;
    }
    Object.defineProperty(GroupField.prototype, "dataField", {
        get: function () {
            return this._dataField;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupField.prototype, "displayField", {
        get: function () {
            return this._displayField;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupField.prototype, "notFoundText", {
        get: function () {
            return this._notFoundText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupField.prototype, "tableField", {
        get: function () {
            return this._tableField;
        },
        enumerable: true,
        configurable: true
    });
    return GroupField;
}());
exports.GroupField = GroupField;
//# sourceMappingURL=GroupField.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/GroupField.js
// module id = 8
// module chunks = 0